import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  heading: FelaCSS;
  articleWrap: FelaCSS;
  articleList: FelaCSS;
}

const style = (): IStyles => ({
  wrapper: {
    maxWidth: '1215px',

    maxWidthTabletSm: {
      maxWidth: 350,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  heading: {
    marginBottom: 4,
    fontDefaultSemiBold: 22,
    marginLeft: 4,
  },

  articleWrap: {
    marginBottom: 4,
    maxWidthTabletSm: {
      width: '350px',
    },
    minWidthTabletLg: {
      marginHorizontal: 4,
    },
  },

  articleList: {
    gridTemplateColumns: 'repeat(18, 1fr)',
    paddingBottom: 4,
    maxWidthTabletSm: {
      display: 'flex',
      overflowX: 'auto',
      flexDirection: 'row',
    },
  },
});

export default style;
